import clsx from 'clsx';

// components
import Icon, { IconProps } from '@/components/elements/Icon';

type Size = `small` | `medium` | `large`;

export type SpinnerProps = {
  size?: Size;
} & IconProps;

/**
 * @component Spinner
 */
function Spinner({ size = `medium`, className, ...rest }: SpinnerProps) {
  const classes = clsx(`animate-spin`, className);
  return (
    <Icon className={classes} size={size} fill="none" {...rest}>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </Icon>
  );
}

export default Spinner;
